import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        fill="#ffffff"
        d="M30.136 26.832a11.746 11.746 0 003.512-8.358 10.725 10.725 0 00-3.148-7.652 10.924 10.924 0 00-9.03-3.052 4.614 4.614 0 00-8.848 1.84 4.57 4.57 0 00.91 2.726A11.453 11.453 0 0012 14.776l-.022.06a11.272 11.272 0 00.258 9.814l-4.54 3.76a3.8 3.8 0 00-1.338 2.658 3.502 3.502 0 001.02 2.72c.04.063.089.12.144.172a3.652 3.652 0 002.55 1.048h.186a3.697 3.697 0 002.614-1.298l3.8-4.61a11.312 11.312 0 009.914.2 12.036 12.036 0 003.55-2.468zm-1.048-14.6a8.736 8.736 0 012.56 6.238 9.754 9.754 0 01-2.926 6.942 10.098 10.098 0 01-2.4 1.742L14.158 15c.254-.477.548-.932.88-1.358.672.377 1.429.578 2.2.584a4.613 4.613 0 004.6-4.494 8.912 8.912 0 017.25 2.506v-.006zM17.24 7a2.618 2.618 0 110 5.235 2.618 2.618 0 010-5.235zm-.264 19.97a1 1 0 00-1.306.2l-4.34 5.26a1.674 1.674 0 01-1.176.576 1.635 1.635 0 01-1.2-.44 1.612 1.612 0 00-.106-.122 1.617 1.617 0 01-.498-1.278c.04-.477.268-.92.632-1.23l5.184-4.284a1 1 0 00.2-1.31 9.088 9.088 0 01-1.026-7.328l10.968 10.968a9.144 9.144 0 01-7.332-1.02v.008z"
      ></path>
    </svg>
  );
}

export default Icon;